// extracted by mini-css-extract-plugin
module.exports = {"item":"item-module--item--p8D7n","shadow":"item-module--shadow--9dk0P","pic":"item-module--pic--2EEQM","hidden":"item-module--hidden--1aG7C"};